/**
 * Composable to manage the hydration of the Pinia
 * Necessary to run on Cloudflare Workers
 */

export const usePiniaHydration = () => {
  const isHydrated = ref(false);
  const hydrationPromise = ref<Promise<void> | null>(null);

  async function waitForHydration(): Promise<void> {
    if (isHydrated.value) {
      return;
    }

    if (hydrationPromise.value) {
      await hydrationPromise.value;

      return;
    }

    hydrationPromise.value = new Promise((resolve) => {
      if (!process.client) {
        isHydrated.value = true;
        resolve();

        return;
      }

      const checkHydration = () => {
        try {
          const { isAuthenticated } = storeToRefs(useAuthStore());

          if (isAuthenticated !== undefined) {
            isHydrated.value = true;
            resolve();

            return;
          }
        } catch (e) {}

        setTimeout(checkHydration, 10);
      };

      checkHydration();
    });

    await hydrationPromise.value;
  }

  async function waitForUserData(): Promise<{
    isAuthenticated: boolean;
    user: any;
    userData: any;
  }> {
    await waitForHydration();

    if (process.client) {
      await new Promise((resolve) => setTimeout(resolve, 50));
    }

    const { isAuthenticated } = storeToRefs(useAuthStore());
    const { user } = storeToRefs(useUserDataStore());
    const userData = useUserData();

    return {
      isAuthenticated: isAuthenticated.value,
      user: user.value,
      userData,
    };
  }

  function checkIfHydrated(): boolean {
    return isHydrated.value;
  }

  return {
    isHydrated: readonly(isHydrated),
    waitForHydration,
    waitForUserData,
    checkIfHydrated,
  };
};
